import type { SVGComponentProps } from 'BreetHelpers';

export const MoneyBagIcon = ({ ...rest }: SVGComponentProps) => (
	<svg
		width='10'
		height='12'
		viewBox='0 0 10 12'
		fill='none'
		xmlns='http://www.w3.org/2000/svg'
		{...rest}
	>
		<path
			d='M6.02735 0H3.13341C2.77729 0 2.55441 0.385766 2.73264 0.694239L3.74523 2.44853H5.41553L6.42829 0.694239C6.6067 0.385766 6.38382 0 6.02735 0Z'
			fill='var(--color-tertiary-400)'
		/>
		<path
			d='M5.62288 3.26562H3.53824C1.476 3.9011 0 5.60457 0 7.60663C0 7.68886 0.00247058 7.77057 0.00741241 7.85174C0.124059 9.77881 1.79418 11.2465 3.72476 11.2465H5.43618C7.36659 11.2465 9.03671 9.77881 9.15353 7.85174C9.15847 7.77057 9.16094 7.68886 9.16094 7.60663C9.16094 5.60457 7.68477 3.90128 5.62288 3.26562Z'
			fill='var(--color-tertiary-400)'
		/>
		<path
			d='M6.47565 2.86111C6.47565 3.00529 6.41759 3.13676 6.32282 3.23135C6.22806 3.32611 6.09465 3.38417 5.95047 3.38417H3.20794C2.91747 3.38417 2.68506 3.14964 2.68506 2.86111C2.68506 2.71694 2.74312 2.58352 2.83788 2.48876C2.93247 2.394 3.06394 2.33594 3.20794 2.33594H5.95047C6.24094 2.33594 6.47565 2.57064 6.47565 2.86111Z'
			fill='var(--color-tertiary-500)'
		/>
	</svg>
);
